import styled, { css } from "styled-components";
import PropTypes from "prop-types";

import { spacing } from "core/spacing";
import breakpoints from "core/breakpoints";
import colors from "core/colors";

import {
    handleBottomSpacing,
    handleTopSpacing
} from "js/helpers/spacingAndFonts";
import { convertPxToRem } from "frontend/components/helpers";

// OuterContainer:
export const OuterContainer = styled.section`
    ${({ bgColor }) =>
        `background-color: ${bgColor ? bgColor : colors.primary.snow};`}
    ${({ textColor }) => textColor && `color: ${textColor};`}
    ${({ fullWidth }) =>
        fullWidth &&
        `width: 100%;
        position: relative;
    `}

    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        overflow-x: hidden;
    }
`;

OuterContainer.propTypes = {
    bgColor: PropTypes.string
};

// Container:
const containerProps = css`
    ${({ removePadding }) => removePadding && "padding: 0 !important;"}

    ${({ removeLeftRightPadding }) =>
        removeLeftRightPadding &&
        "padding-left: 0 !important; padding-right: 0 !important;"}

    ${({ fullWidth }) =>
        fullWidth &&
        css`
            max-width: 100%;
        `}
`;

export const Container = styled.section`
    margin: 0 auto;
    position: relative;
    width: 100%;
    max-width: 85.38rem; /* 1366px */

    /* isHero flag only affects home page as of 03/25/2022: */
    ${({ isHero }) =>
        isHero &&
        css`
            //desktop-only:
            @media (min-width: ${breakpoints.desktop.rem}) {
                // constrain desktop height per product requirements
                height: ${convertPxToRem({ px: 685.51 })};
            }

            // larger custom desktop breakpoint to refactor at a later date:
            @media (min-width: 1380px) {
                max-width: 100%;
            }
        `} 
        /* ^^ the purpose of this is so that the icons in the hero are all shown;
         we will need to refactor once we are using things other than SVGs/using the hero on other pages */

    
    /* alternative top & bottom spacing to change the default spacing: */
    ${({ topSpacing }) => handleTopSpacing({ topSpacing })}
    ${({ bottomSpacing }) => handleBottomSpacing({ bottomSpacing })}

    /* Mobile - Default spacing for SectionContainer: */
    padding-left: ${convertPxToRem({ px: 15 })};
    padding-right: ${convertPxToRem({ px: 15 })};

    ${containerProps};
    
    ${({ isHero }) => isHero && spacing.mobile.HeroTopAndBottom} 

    /* Tablet - Default spacing for SectionContainer: */
    @media (min-width: ${breakpoints.tablet.rem}) {
        padding-left: ${convertPxToRem({ px: 20 })};
        padding-right: ${convertPxToRem({ px: 20 })};

        ${containerProps}
            
        ${({ isHero }) => isHero && spacing.tablet.HeroTopAndBottom} 
    }

    /* Desktop - Default spacing for SectionContainer: */
    @media (min-width: ${breakpoints.desktop.rem}) {
        padding-left: ${convertPxToRem({ px: 24 })};
        padding-right: ${convertPxToRem({ px: 24 })};

        ${containerProps};

        ${({ isHero }) => isHero && spacing.desktop.HeroTopAndBottom} 

         /* Screens with laptop height range - Default spacing for SectionContainer: */
        @media ${breakpoints.laptopHeightsRange.rem} {
            ${containerProps}

            ${({ isHero }) => isHero && spacing.tablet.HeroTopAndBottom}    
        }

    }
`;

Container.propTypes = {
    removePadding: PropTypes.bool,
    removeLeftRightPadding: PropTypes.bool,
    isHero: PropTypes.bool
};
